// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__JRvsi","between":"style_between__zx5Sl","end":"style_end__ezSKw"};